export const TEMP_WHITE_LIST = {
	["0xcd4C346942D5cA794009dA18ba2AA0cCCd221AF8".toLowerCase()]: "jsg funder",
	["0x7A4AA5553120c725F4A0b8235aC4d6753339e533".toLowerCase()]: "jsg buyer",
	["0xb22adA27946C0494077f6FD42e93f5f1Cd6Ae240".toLowerCase()]: "jsg owner",
	["0x04F914c65E72236e93E13CaEacAab390c7FD2972".toLowerCase()]: "jsg torus",
	["0xe81C533237678F59E37BF8F2Cb7027A71994a57e".toLowerCase()]: "ArcShort!",
	["0xf4a62218B89fdA6a0156b7546Fc2650d188FDdAA".toLowerCase()]: "ArcShort",
	["0xEe8BADbe45AC071f43952B9C2d145B116a8E75f4".toLowerCase()]: "ArcLong!",
	["0x2F2abcf3f46891Bc03F209Fd06803D1Ba9995dbf".toLowerCase()]: "ArcLong",
	["0xbb8bB7571a4f6754a424e0A863D1073F6319f548".toLowerCase()]: "Queen1",
	["0x08f1D38a488d21B357F7d207eAC7dE27C65C7a89".toLowerCase()]: "Queen2",
	["0x905B607146A6236F8f1e5C18cB1179985D246525".toLowerCase()]: "Queen3",
	["0xB8B86415c8F407F976A163713b4f2DCAbd5c9b9e".toLowerCase()]: "LeahLong",
	["0xd58fB7591494812F649834bCa54811bd67568444".toLowerCase()]: "LeahLong!",
	["0x8f31f0228CaCE28eb31E0Ba072De57A463Ecb81E".toLowerCase()]: "LeahShort",
	["0xa5Be4534Dd31e82C0955e1fD7300b894DaB48F20".toLowerCase()]: "LeahShort!",
	["0x50f69eD6351164Ec6Aca79A2B1bc574777056730".toLowerCase()]: "PepeShort!",
	["0x0315EfAeB5D076e7f5d42Ac7a399395b29AF8979".toLowerCase()]: "PepeShort",
	["0xc947c5737D7a05a2318bfee7b77B52942c5856C0".toLowerCase()]: "PepeLong!",
	["0xFB4d49f09A0f0Dc1a32941D43D89171Da9BF309D".toLowerCase()]: "PepeLong",
	["0x65b835F4972cEe4d2905f827ED706945900f1E6e".toLowerCase()]: "ThreeFiveSig",
	["0x293e97b593a45c20eD706a26B3F77D36E227407f".toLowerCase()]: "EpochImbalBuyer",
	["0xC31D9C1Bd55fac4489292Ee8A4E68AdFe013c567".toLowerCase()]: "ManuShared",
	["0xf39Fd6e51aad88F6F4ce6aB8827279cffFb92266".toLowerCase()]: "AWSmanuOwner",
	["0x8C5C9BDa2121206724b4541753010525AC85d516".toLowerCase()]: "PW1",
	["0x03D0b9C16f5abfeBa42416F99F4000f12B13444e".toLowerCase()]: "PW2",
	["0xB8B86415c8F407F976A163713b4f2DCAbd5c9b9e".toLowerCase()]: "PW3",
	["0x8f31f0228CaCE28eb31E0Ba072De57A463Ecb81E".toLowerCase()]: "PW4",
	["0x86262f79483ee7Dbc2570EccF5bDd0B19D0FF5C2".toLowerCase()]: "Jesse1",
	["0x878CDd5b17dFbC449a286bb5169f95d5622186bB".toLowerCase()]: "Scribe1",
	["0x2e31684f48de9b7f7bffc10ffeb39b610114e6e3".toLowerCase()]: "Scribe2",
	["0x83DB892a6688B966122Be219fa873BF24D7db79F".toLowerCase()]: "Scribe3",
	["0x266d9ea940c667d97485089981f886963185c63d".toLowerCase()]: "Scribe4",
	["0x400db239e38e4e7d39b149f28d7bae1cf94e59a3".toLowerCase()]: "Scribe5",
	["0x9E72d655515203c30F8890a2bC24740c85D6dCFc".toLowerCase()]: "VaultOpener",
	["0x3Acd29C452f39C61a146B92b483a7BC017108dEb".toLowerCase()]: "Verikono",
	["0xb8CD233fA8233F5BB3879234431dcd939480cB4E".toLowerCase()]: "Bren2",
	["0xbd20D26492D33C09b0D4F29dD8cd1365a1910d57".toLowerCase()]: "Bitget",
	["0x3cBa0AAf43C8E77F1E78eE87759000aEA8c0e0d7".toLowerCase()]: "ReferralTestWallet",
	["0xD40a658E89170B3FD28009aE55c4D98fe2ad6fb0".toLowerCase()]: "Boreal",
	["0xEe8BADbe45AC071f43952B9C2d145B116a8E75f4".toLowerCase()]: "JSG Escrow",
	["0xd0C335aFb631fff0e23b030761eaA6818Fd67441".toLowerCase()]: "JSG Nano",
	["0xcF671f26070Aa900e363327497b8B7Cea811DcE2".toLowerCase()]: "Evan Wallet",
	["0x9C5111176B4d6DE6489cA552BAa37A78Bf96ef95".toLowerCase()]: "Brens Fordefi",
	["0xB0d73407076aDd4a9A49C75C023990Ac34526714".toLowerCase()]: "CBOR2 Manager",
	["0xc3AFCcfC3B59F9f5046477cd9410C263191161e2".toLowerCase()]: "Boreal2/5",
	["0x58aDe11a5241b86C6C22C6914d5c647109ECf940".toLowerCase()]: "BracketClaim",
	["0x3268221E4bA1ac704860654d8B5E95ddA99d7e20".toLowerCase()]: "TestMGMT",
	["0x34ae653aB14cDE1a56D10CAC515c9873726E637f".toLowerCase()]: "PennyWorks",
	["0xfE7AaDFAD823B1C90480031e9046a085ef2c3788".toLowerCase()]: "Avant NAV Updater",
	["0xe139A0C83C0735b3741b6A3782cE9019e1D28b5C".toLowerCase()]: "Avant Vault Admin",
	["0x6CF2dd3b2323782Bd043b3DEeD8df4EFf706208b".toLowerCase()]: "Jason Wallet 2",
	["0xcd4C346942D5cA794009dA18ba2AA0cCCd221AF8".toLowerCase()]: "Jason Mobile",
	["0xF0753b84aDc6794171F12879EABa3D8eB1fb4d2D".toLowerCase()]: "Mike Wallet 1",
	["0x849c73755CF6DEC9F0C0E166d310Afe14a569e4E".toLowerCase()]: "Mike Wallet 2",
};
